import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ToastComponent } from './toast/toast.component';


@NgModule({
  declarations: [
    ToastComponent,
  ],
  imports: [
    CommonModule,
    ToastModule,
    DialogModule,
  ],
  providers: [
    MessageService,
  ],
  exports: [
    ToastComponent,
  ],
})
export class UiNotificationsModule {
}
